<ngx-loading-bar color="rgb(74, 217, 164)" [includeSpinner]="false" diameter="25px" height="4px"></ngx-loading-bar>
<router-outlet></router-outlet>
